import React from 'react';
import PropTypes from 'prop-types';
import TenureDisplay from '../tenure-display';

function TenureRenderer(props) {
  const { value, short } = props;
  return (
    <TenureDisplay value={value} short={short} />
  );
}

TenureRenderer.propTypes = {
  value: PropTypes.number,
  short: PropTypes.bool,
};
TenureRenderer.defaultProps = {
  value: null,
  short: true,
};

export default TenureRenderer;
